import { Check, RotateCcw } from "lucide-react";

export const PERMISSAO_REABRIR = "pedido_reabrir";

const REABRIR = {
  id: PERMISSAO_REABRIR,
  label: "Reabrir pedido concluído",
  hint: "Corrigir forma de pagamento e desconto depois de fechado, enquanto o caixa estiver aberto",
};

/** Bloco "Pedidos" do cadastro de funcionário: pode reabrir pedido concluído?
 *  A chave mora em `allowed_modules`, como as do caixa. `extras` são outras
 *  ações de pedido ({id, label, hint}) que a página queira no mesmo bloco. */
export default function PermissaoReabrir({ selecionadas, onToggle, extras = [] }) {
  return (
    <div className="border rounded-xl p-4 bg-muted/20" data-e2e="permissao-reabrir">
      <div className="mb-3">
        <p className="text-sm font-semibold flex items-center gap-1.5"><RotateCcw className="w-4 h-4 text-primary" />Pedidos</p>
        <p className="text-[11px] text-muted-foreground">Dono e administrador sempre podem.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {[REABRIR, ...extras].map((p) => {
          const ligada = selecionadas.includes(p.id);
          return (
            <button key={p.id} type="button" onClick={() => onToggle(p.id)} data-e2e={`perm-${p.id}`}
              className={`flex items-center justify-between gap-2 px-3 py-2 rounded-lg border text-left transition-all ${ligada ? "border-primary bg-primary/5 hover:bg-primary/10" : "border-border bg-background hover:border-muted-foreground/40"}`}>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${ligada ? "text-foreground" : "text-muted-foreground"}`}>{p.label}</p>
                <p className="text-[10px] text-muted-foreground">{p.hint}</p>
              </div>
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 ${ligada ? "border-primary bg-primary" : "border-muted-foreground/40"}`}>
                {ligada && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
